import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';

import { GeoPoint } from './geopoint';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  coordinates: Array<GeoPoint>;

  constructor(private fs: AngularFirestore, private route: Router) {
    // console.log(route);
    if (route.url == "/test") {
      // this.points == "test-points";
    }
  }

  // points: string;

  getPathCoordinates(id: number): Observable<any> {
    console.log(id.toString());
    const pathDocuments = this.fs.doc('paths/' + id);
    console.log('paths/'+id);
    return pathDocuments.snapshotChanges();
  }

  getPaths(): Observable<any> {
    return this.fs.collection("paths").snapshotChanges();
  }

  checkCoordinates(id: number): Observable<any> {
    const pathDocuments = this.fs.doc('points/' + id);
    return pathDocuments.snapshotChanges();
  }

  getAllPoints(points: string): Observable<any> {
    return this.fs.collection(points).get();
  }

  getPointBySlug(slug: string): Promise<any> {
    var pointsRef = this.fs.collection("points");
    return pointsRef.ref.where("slug", "==", slug).get();
  }
}
